class UtilsFunctions {
    capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
}

export default new UtilsFunctions();